import { Select as AntSelect } from 'antd'
import type { SelectProps } from 'antd'
import { SIZE_MAP } from '../types'
import type { Size } from '../types'

export interface AppSelectProps extends Omit<SelectProps<any, any>, 'size'> {
  size?: Size
}

export const AppSelect = ({ size = 'md', ...rest }: AppSelectProps) => <AntSelect size={SIZE_MAP[size]} {...rest} />

export const AppSelectOption = AntSelect.Option
